module.exports = __webpack_public_path__ + "static/media/refresh_item.0b457b37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/bonuses/refresh_item.svg
// module id = 177
// module chunks = 0